import React, { useState, useEffect } from 'react';
import { t } from '../i18n';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { productionAPI } from '../api';
import toast from 'react-hot-toast';

const ROLE_LABELS = {
  admin:      'Администратор',
  manager:    'Менеджер по продажам',
  technolog:  'Технолог',
  operator:   'Оператор пресса',
  sklad_gp:   'Кладовщик СГП',
  director:   'Директор',
  controller: 'Контролёр качества',
  buhgalter:  'Бухгалтер',
};

const S = {
  input: {
    width: '100%', padding: '10px 14px', background: 'var(--bg)',
    border: '1px solid var(--border)', borderRadius: 8,
    color: 'var(--text)', fontSize: 14, outline: 'none', boxSizing: 'border-box',
  },
  label: { display: 'block', color: 'var(--muted)', fontSize: 12, marginBottom: 5 },
};

export default function ProfilePage() {
  const navigate = useNavigate();
  const role = sessionStorage.getItem('role') || '';

  const [me, setMe] = useState(null);

  // Форма смены пароля
  const [oldPw,  setOldPw]  = useState('');
  const [newPw,  setNewPw]  = useState('');
  const [newPw2, setNewPw2] = useState('');
  const [saving, setSaving] = useState(false);

  // Форма имени
  const [firstName, setFirstName] = useState('');
  const [lastName,  setLastName]  = useState('');
  const [savingName, setSavingName] = useState(false);

  useEffect(() => {
    productionAPI.getMe().then(r => {
      setMe(r.data);
      setFirstName(r.data.first_name || '');
      setLastName(r.data.last_name   || '');
    });
  }, []);

  const handlePassword = async (e) => {
    e.preventDefault();
    if (newPw !== newPw2) { toast.error(t("Пароли не совпадают")); return; }
    if (newPw.length < 6) { toast.error(t("Минимум 6 символов")); return; }
    setSaving(true);
    try {
      await productionAPI.changePassword({ old_password: oldPw, new_password: newPw });
      toast.success(t("✅ Пароль изменён"));
      setOldPw(''); setNewPw(''); setNewPw2('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Ошибка');
    } finally { setSaving(false); }
  };

  const handleName = async (e) => {
    e.preventDefault();
    setSavingName(true);
    try {
      const r = await productionAPI.updateProfile({ first_name: firstName, last_name: lastName });
      sessionStorage.setItem('user_name', r.data.first_name
        ? `${r.data.first_name} ${r.data.last_name}`.trim()
        : r.data.username
      );
      toast.success(t("✅ Данные обновлены"));
    } catch { toast.error(t("Ошибка")); }
    finally { setSavingName(false); }
  };

  return (
    <Layout title={t("Профиль")}>
      <div style={{ maxWidth: 520, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>

        {/* Информация об аккаунте */}
        <div style={{ background: 'var(--card)', borderRadius: 12, padding: 24 }}>
          <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700, marginBottom: 18 }}>
            👤 Мой аккаунт
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              { label: 'Логин',   value: me?.username || '—' },
              { label: 'Роль',    value: ROLE_LABELS[role] || role },
            ].map(row => (
              <div key={row.label} style={{
                background: 'var(--bg)', borderRadius: 8, padding: '10px 14px',
                display: 'flex', justifyContent: 'space-between',
              }}>
                <span style={{ color: 'var(--dim)', fontSize: 13 }}>{row.label}</span>
                <span style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{row.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Изменить имя */}
        <div style={{ background: 'var(--card)', borderRadius: 12, padding: 24 }}>
          <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700, marginBottom: 18 }}>
            ✏ Изменить имя
          </h2>
          <form onSubmit={handleName} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={S.label}>{t('Имя')}</label>
                <input
                  value={firstName}
                  onChange={e => setFirstName(e.target.value)}
                  placeholder={t("Иван")}
                  style={S.input}
                />
              </div>
              <div>
                <label style={S.label}>{t('Фамилия')}</label>
                <input
                  value={lastName}
                  onChange={e => setLastName(e.target.value)}
                  placeholder={t("Иванов")}
                  style={S.input}
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={savingName}
              style={{
                background: savingName ? 'var(--card)' : 'var(--accent)',
                border: 'none', borderRadius: 8, color: savingName ? 'var(--mid)' : '#fff',
                padding: '10px 0', fontSize: 14, fontWeight: 600,
                cursor: savingName ? 'not-allowed' : 'pointer',
              }}
            >
              {savingName ? 'Сохранение...' : 'Сохранить имя'}
            </button>
          </form>
        </div>

        {/* Смена пароля */}
        <div style={{ background: 'var(--card)', borderRadius: 12, padding: 24 }}>
          <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700, marginBottom: 18 }}>
            🔒 Сменить пароль
          </h2>
          <form onSubmit={handlePassword} autoComplete="off"
            style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label style={S.label}>{t('Текущий пароль')}</label>
              <input
                type="password" value={oldPw}
                onChange={e => setOldPw(e.target.value)}
                placeholder={t("Введите текущий пароль")}
                autoComplete="new-password"
                style={S.input} required
              />
            </div>
            <div>
              <label style={S.label}>{t('Новый пароль')}</label>
              <input
                type="password" value={newPw}
                onChange={e => setNewPw(e.target.value)}
                placeholder={t("Минимум 6 символов")}
                autoComplete="new-password"
                style={S.input} required
              />
            </div>
            <div>
              <label style={S.label}>{t('Повторите новый пароль')}</label>
              <input
                type="password" value={newPw2}
                onChange={e => setNewPw2(e.target.value)}
                placeholder={t("Повторите пароль")}
                autoComplete="new-password"
                style={{
                  ...S.input,
                  borderColor: newPw2 && newPw !== newPw2 ? '#ef4444' : 'var(--border)',
                }} required
              />
              {newPw2 && newPw !== newPw2 && (
                <div style={{ color: '#ef4444', fontSize: 12, marginTop: 4 }}>
                  Пароли не совпадают
                </div>
              )}
            </div>
            <button
              type="submit"
              disabled={saving || (newPw2 && newPw !== newPw2)}
              style={{
                background: saving ? 'var(--card)' : '#22c55e',
                border: 'none', borderRadius: 8,
                color: saving ? 'var(--mid)' : '#fff',
                padding: '10px 0', fontSize: 14, fontWeight: 600,
                cursor: saving ? 'not-allowed' : 'pointer',
              }}
            >
              {saving ? 'Сохранение...' : '🔒 Изменить пароль'}
            </button>
          </form>
        </div>

        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none', border: '1px solid var(--border)',
            borderRadius: 8, color: 'var(--muted)', padding: '10px 20px',
            fontSize: 14, cursor: 'pointer', alignSelf: 'flex-start',
          }}
        >
          ← Назад
        </button>
      </div>
    </Layout>
  );
}
